import { cva } from 'class-variance-authority';

import s from './Avatar.module.css';

export const avatarVariants = cva(s.avatar, {
  defaultVariants: {
    size: 'default',
    withBorder: false,
  },

  variants: {
    size: {
      default: s['avatar--size-default'],
      large: s['avatar--size-large'],
      small: s['avatar--size-small'],
    },
    withBorder: {
      true: s['avatar--with-border'],
    },
  },
});
